import browserUpdate from 'browser-update/update.npm.js';
import { Component } from 'react';

export class BrowserUpdate extends Component {

    render() {
        const sharedMessageConfiguration = {
            remind: '',
            bnever: '',
            shift_page_down: false,
        };

        const browserUpdateOptions = {
            /*
            IE all versions should show banner(by default),
            All other browser should skip the previous version from that of current 
            version to show banner
          */
            required: { i: 0, e: -1, f: -1, o: -1, s: -1, c: -1 },
            insecure: true, // browser that are severely insecure get notified.
            style: 'top',
            l: 'en', // setting this language property triggers the library to use the translated messages.
            reminder: 0, // after how many hours should the message reappear // 0 = show all the time doesn't explicitly closes the message.
            reminderClosed: 24, // if the user explicitly closes message it reappears after x hours
            api: 2020.08,
            notify_esr: true, // Notifies Firefox ESR versions if they are below requirement
            onshow() {
                document.getElementById('buorgig').setAttribute('href', '#!');
            },
            text: {
                msg: 'Your web browser ({brow_name}) is out of date.',
                msgmore: 'Update your browser for more security, speed and the best experience on this site.',
                bignore: 'Ignore',
                ...sharedMessageConfiguration,
            },
            text_es: {
                msg: 'Su navegador ({brow_name}) está desactualizado.',
                msgmore:
                    'Actualice su navegador para mayor seguridad, velocidad, y la mejor experiencia posible en este sitio web.',
                bignore: 'Ignorar',
                ...sharedMessageConfiguration,
            },
            text_ht: {
                msg: 'Navigatè entènèt ({brow_name}) ou an demode.',
                msgmore: 'Mete navigatè ou an ajou pou plis sekirite, vitès ak pi bon eksperyans lan sou sit sa a.',
                bignore: 'Inyore',
                ...sharedMessageConfiguration,
            },
            text_il: {
                msg: 'Ti web browser mo ({brow_name}) ket daanen.',
                msgmore:
                    'Pabaroem ti browser mo para iti nasaysayaat a seguridad, pardas, ken kasayaatan a kapadasan iti daytoy a site.',
                bignore: 'Bay-an',
                ...sharedMessageConfiguration,
            },
            text_kr: {
                msg: '귀하의 웹 브라우저({brow_name})는 최신 버전이 아닙니다.',
                msgmore: '이 사이트의 보안, 속도 및 최상의 경험을 위해 브라우저를 업데이트하십시오.',
                bignore: '무시',
                ...sharedMessageConfiguration,
            },
            text_ta: {
                msg: 'Ang iyong web browser ({brow_name}) ay luma na.',
                msgmore:
                    'I-update ang iyong browser para sa higit pang seguridad, bilis at ang pinakamahusay na karanasan sa site na ito.',
                bignore: 'Huwag pansinin',
                ...sharedMessageConfiguration,
            },
            text_vi: {
                msg: 'Trình duyệt web của bạn ({brow_name}) đã lỗi thời.',
                msgmore: 'Cập nhật trình duyệt của bạn để có thêm bảo mật, tốc độ và trải nghiệm tốt nhất trên trang web này.',
                bignore: 'Bỏ qua',
                ...sharedMessageConfiguration,
            },
            text_zh: {
                msg: '您的網路瀏覽器（{brow_name}）已過期。',
                msgmore: '更新您的瀏覽器，以提高在本網站上的安全性、速度和獲得最佳體驗。',
                bignore: '忽略',
                ...sharedMessageConfiguration,
            },
        };

        /*
          Below function Loads the browser update script from cdn because of frequent updates to the detection code in this file
          If the script execution fails then it loads a fallback via node modules as we import.
        */
        // NOTE Disabled with assumption of library-specific naming convention
        // eslint-disable-next-line camelcase
        const $buo_f = () => {
            const e = document.createElement('script');
            e.src = '//browser-update.org/update.min.js';
            document.body.appendChild(e);
        };
        try {
            window.$buoop = browserUpdateOptions;
            $buo_f();
        } catch (e) {
            browserUpdate(browserUpdateOptions);
        }
        // Setting the Update browser button not accessible by screen reader.
        const element = document.getElementById('buorgul');
        if (element) {
            element.parentNode.removeChild(element);
        }
        return element;
    }
}

export default BrowserUpdate;
